export enum MembershipStatus {
    ACTIVE = 'active',
    SUSPENDED = 'suspended',
    PENDING = 'pending_payment',
    CANCELLED = 'cancelled'
}